import React from "react";
const TextArea = ({
  label,
  rows,
  name,
  size,
  placeholder,
  required,
  value,
  onChange,
  disabled,
  checked,
  icon,
}) => {
  const handleChange = (e) => {
   
      const { name, value } = e.target;
      onChange("textArea", name, value);
    
  };

  return (
    <div className={"col-lg-" + size}>
        
          <div className="form-group mt-2">
            <label for="name" className="col-sm-12">
              <i className={icon} style={{ fontSize: "20px" }} />
              <i /> {label}:{/* Page Layout */}
            </label>
            <div className="col-sm-12">
              <textarea
                disabled={disabled}
                className="form-control"
                required={required}
                rows={rows}
                name={name}
                placeholder={placeholder}
                value={value}
                onChange={handleChange}
              />
            </div>
          </div>
        
    </div>
  );
};

export default TextArea;
